import React from "react";
import "./Styles/Livestream.css";
import { CiSearch } from "react-icons/ci";
import CustomSelectProps from "../Components/CustomSelect/Customselect";
// import { colourOptions } from "../data";

const Livestream = () => {
  return (
    <>
      <div className="course-flex mb-56">
        <div className="course-inputs">
          {/* Use CustomSelectProps for Course Name */}
          {/* <CustomSelectProps
          
            placeholder="Course Name"
            isSearchable
            className="select-dropdown" 
          /> */}
        </div>

        <div className="course-inputs">
          {/* Use CustomSelectProps for Batch Name */}
          {/* <CustomSelectProps
            placeholder="Batch Name"
            isSearchable
            className="select-dropdown" 
          /> */}
        </div>
      </div>

      <div className="d-flex justify-content-center flex-direction-column">
        <div className="stream-video">
          <div className="video-div">
            <img
              src={require("../Pages/images/video.webp")}
              alt="Video"
              className="video-img"
            />
          </div>
          <button className="live-btn">Go Live Now</button>
        </div>
      </div>
    </>
  );
};

export { Livestream };
